document.addEventListener("DOMContentLoaded", function () {
  var layouts = document.querySelectorAll(".ts-layout");

  layouts.forEach(function (layout) {
    /* 1. SETUP DOM ELEMENTS */
    var section = layout.closest('.ts-section');
    var preview = layout.querySelector(".ts-preview");
    var previewImgBlur = preview ? preview.querySelector(".ts-layer-blur") : null;
    var previewImgMain = preview ? preview.querySelector(".ts-layer-main") : null;
    var previewImgLegacy = preview ? preview.querySelector(".ts-preview__img:not(.ts-layer-blur):not(.ts-layer-main)") : null;

    var previewLabelSpan = layout.querySelector(".js-ts-preview-label");
    var previewTitleSpan = layout.querySelector(".js-ts-preview-title");
    var previewButton = layout.querySelector(".js-ts-preview-link");
    var titleBar = preview ? preview.querySelector(".ts-preview__title-bar") : null;

    /* Animation toggles */
    var hasTitleAnim = layout.getAttribute("data-anim-title-bar") === "true" && layout.getAttribute("data-anim-enabled") === "true";
    var hasReveal = layout.getAttribute("data-anim-preview-fade") === "true" && layout.getAttribute("data-anim-enabled") === "true";
    var hasBreathe = layout.getAttribute("data-anim-preview-breathe") === "true" && layout.getAttribute("data-anim-enabled") === "true";
    var hasGlow = layout.getAttribute("data-anim-preview-glow") === "true" && layout.getAttribute("data-anim-enabled") === "true";

    /* Activate breathe / glow on initial load */
    var targetImg = previewImgMain || previewImgLegacy;
    
    /* FIX: Apply breathe to blur layer too so sizes match during transition */
    if (previewImgBlur && hasBreathe) {
      previewImgBlur.classList.add("ts-anim-breathe");
    }

    if (targetImg) {
      if (hasBreathe) targetImg.classList.add("ts-anim-breathe");
      if (hasGlow) targetImg.classList.add("ts-anim-glow");
    }

    /* TRACKER FOR MODES */
    var currentMode = 'dark'; // 'dark' or 'light'
    var currentVariant = 'std'; // 'std' or 'alt'
    var activeBtn = layout.querySelector('.ts-thumb.is-active') || layout.querySelector('.ts-thumb');

    /* --- SWITCH LOGIC (CHECKBOXES) --- */
    var modeCheckbox = layout.querySelector('#toggle-color');
    var variantCheckbox = layout.querySelector('#toggle-variant');
    var variantWrapper = layout.querySelector('.ts-control-variant');

    // 1. Color Switch (Black/White)
    if (modeCheckbox) {
      modeCheckbox.addEventListener('change', function() {
        currentMode = this.checked ? 'light' : 'dark';
        section.classList.toggle('mode-light', currentMode === 'light');
        
        updateAllThumbs(); // Update all small images
        if (activeBtn) updatePreview(activeBtn); // Update big preview
      });
    }

    // 2. Variant Switch (Cat/Dog)
    if (variantCheckbox) {
      variantCheckbox.addEventListener('change', function() {
        currentVariant = this.checked ? 'alt' : 'std';
        
        updateAllThumbs(); // Update all small images
        if (activeBtn) updatePreview(activeBtn); // Update big preview
      });
    }

    /* --- HELPER: UPDATE ALL GRID THUMBNAILS --- */
    function updateAllThumbs() {
        var thumbs = layout.querySelectorAll(".ts-thumb");
        thumbs.forEach(function(btn) {
            var img = btn.querySelector("img");
            if (!img) return;

            // Determine which source to use based on state
            var newSrc = "";
            if (currentVariant === 'std') {
               newSrc = (currentMode === 'dark') ? btn.dataset.thumbDark : btn.dataset.thumbLight;
            } else {
               newSrc = (currentMode === 'dark') ? btn.dataset.thumbAltDark : btn.dataset.thumbAltLight;
            }

            // Fallback to standard dark if specific one is missing
            if(!newSrc) newSrc = btn.dataset.thumbDark;
            
            if(newSrc && img.src !== newSrc) {
                img.src = newSrc;
            }
        });
    }


    /* 2. MASTER CONTROLLER: EVENT DELEGATION */
    layout.addEventListener("click", function(e) {
      var btn = e.target.closest(".ts-thumb");
      if (!btn) return;
      
      activeBtn = btn; // Update tracker

      /* NEW: CHECK FOR DEFAULT ALT SETTING 
         If this block is set to default to "Variant B" (Dog), force the switch 
      */
      var defaultAlt = (btn.getAttribute('data-default-alt') === 'true');
      
      if (defaultAlt) {
         currentVariant = 'alt';
         if (variantCheckbox) variantCheckbox.checked = true;
      } else {
         currentVariant = 'std';
         if (variantCheckbox) variantCheckbox.checked = false;
      }
      
      // Update all thumbnails in the grid to match the new mode (so cats flip to dogs or vice versa)
      updateAllThumbs();


      // A. SYNC STATES
      var clickedID = btn.getAttribute("data-block-id");
      var allButtons = layout.querySelectorAll(".ts-thumb");
      
      allButtons.forEach(function(b) {
        if (b.getAttribute("data-block-id") === clickedID) {
          b.classList.add("is-active");
        } else {
          b.classList.remove("is-active");
        }
      });

      updatePreview(btn);
    });

    /* HELPER: UPDATES THE PREVIEW PANE */
    function updatePreview(btn, isInitialLoad) {
      // --- VARIANT LOGIC: THE "DANCING LOGO" ---
      if (variantWrapper) {
          // 1. Get Elements
          var switchEl   = variantWrapper.querySelector('.js-variant-switch');
          var leftLogo   = variantWrapper.querySelector('.js-variant-logo');
          
          // Note: Title and Center Logo are siblings in the title bar
          var titleBarEl = layout.querySelector('.ts-preview__title-bar');
          var centerText = titleBarEl ? titleBarEl.querySelector('.js-ts-preview-title') : null;
          var centerLogo = titleBarEl ? titleBarEl.querySelector('.js-center-logo') : null;

          var hasAltData = (btn.dataset.hasAlt === 'true');

          // Always show the left wrapper
          variantWrapper.style.display = "block";

          if (hasAltData) {
              // SCENARIO A: Variant Exists (e.g., Cat & Dog)
              if(switchEl) switchEl.style.display = ""; 
              if(leftLogo) leftLogo.style.display = "none";

              if(centerText) centerText.style.display = "none";
              if(centerLogo) centerLogo.style.display = "flex";

          } else {
              // SCENARIO B: No Variant (Single design)
              if(switchEl) switchEl.style.display = "none";
              if(leftLogo) leftLogo.style.display = "flex";

              if(centerText) centerText.style.display = "";
              if(centerLogo) centerLogo.style.display = "none";

              // Safety: Reset to standard variant if we were on 'alt'
              // UNLESS we are in "Default to Alt" mode logic which we handle upstream now
              if (currentVariant === 'alt' && !btn.getAttribute('data-default-alt')) {
                  // We only force-reset if the user manually switched to alt but this item DOESNT have one
                  // But since we handle defaults upstream, we should be careful.
                  // Simplest check: if we are in 'alt' mode but this item has NO alt data, revert.
                  currentVariant = 'std';
                  if(variantCheckbox) variantCheckbox.checked = false;
                  updateAllThumbs();
              }
          }
      }

      // B. EXTRACT DATA BASED ON MODE & VARIANT
      var finalSrc = "";
      if (currentVariant === 'std') {
         finalSrc = (currentMode === 'dark') ? btn.dataset.srcDark : btn.dataset.srcLight;
      } else {
         finalSrc = (currentMode === 'dark') ? btn.dataset.srcAltDark : btn.dataset.srcAltLight;
      }
      
      if(!finalSrc) finalSrc = btn.dataset.srcDark || btn.dataset.previewSrc;

      var finalUrl = (currentVariant === 'std') ? btn.dataset.urlStd : btn.dataset.urlAlt;
      if(!finalUrl) finalUrl = btn.dataset.urlStd || btn.dataset.productUrl;

      var imgAlt = btn.getAttribute("data-label") || "";
      var label = btn.getAttribute("data-label") || "Select a design";

      // C. UPDATE UI
      // OPTIMIZATION: Skip reflow/animation trigger on initial load to improve LCP/blocking
      if (!isInitialLoad && hasTitleAnim && titleBar) {
        titleBar.classList.remove("ts-animate");
        void titleBar.offsetWidth; // This triggers the reflow
        titleBar.classList.add("ts-animate");
      }
      
      if (previewTitleSpan) { previewTitleSpan.textContent = label.toUpperCase(); }
      if (previewLabelSpan) { previewLabelSpan.textContent = label; }
      if (previewButton) {
        if (finalUrl) {
          previewButton.href = finalUrl;
          previewButton.removeAttribute("aria-disabled");
        } else {
          previewButton.href = "#";
          previewButton.setAttribute("aria-disabled", "true");
        }
      }

      // D. UPDATE IMAGE
      if (finalSrc) {
        var currentSrc = (previewImgMain) ? previewImgMain.src : (previewImgLegacy ? previewImgLegacy.src : "");
        
        // On initial load, we don't need to fade/reveal if the src is already correct (server-side rendered)
        if (finalSrc !== currentSrc || hasReveal) {
          if (previewImgBlur && previewImgMain) {
            
            // If initial load, just set src without animation overhead
            if (isInitialLoad) {
                previewImgBlur.src = finalSrc; previewImgBlur.srcset = ""; previewImgBlur.alt = imgAlt;
                previewImgMain.src = finalSrc; previewImgMain.srcset = ""; previewImgMain.alt = imgAlt;
                return;
            }

            previewImgMain.style.opacity = '0';
            previewImgBlur.style.opacity = '0';
            
            var loader = new Image();
            loader.onload = function() {
              previewImgBlur.src = finalSrc; previewImgBlur.srcset = ""; previewImgBlur.alt = imgAlt;
              previewImgMain.src = finalSrc; previewImgMain.srcset = ""; previewImgMain.alt = imgAlt;

              previewImgMain.style.opacity = '1';
              previewImgBlur.style.opacity = '1';

              if (hasReveal) {
                previewImgMain.classList.remove("ts-anim-reveal");
                previewImgBlur.classList.remove("ts-anim-hide-delay");
                void previewImgMain.offsetWidth;
                previewImgMain.classList.add("ts-anim-reveal");
                previewImgBlur.classList.add("ts-anim-hide-delay");
              }
            };
            loader.src = finalSrc;

            if (hasBreathe || hasGlow) { previewImgMain.style.animationPlayState = "running"; }
          } 
          else if (previewImgLegacy) {
             var loader = new Image();
             loader.onload = function() {
                previewImgLegacy.src = finalSrc; previewImgLegacy.srcset = ""; previewImgLegacy.alt = imgAlt;
             };
             loader.src = finalSrc;
          }
        }
      }
    }
    
    /* 3. MARQUEE MANAGER */
    var stopMarquee = null;
    function startMarqueeSystem() {
       if (stopMarquee) stopMarquee(); // Cleanup old
       stopMarquee = initMarquee(layout);
    }
    startMarqueeSystem();

    var resizeTimer;
    var lastWidth = window.innerWidth;

    window.addEventListener("resize", function() {
       if (window.innerWidth === lastWidth) return;
       lastWidth = window.innerWidth;
       clearTimeout(resizeTimer);
       resizeTimer = setTimeout(startMarqueeSystem, 200);
    });

    /* 4. OPTIMIZED INITIALIZATION */
    /* We use requestAnimationFrame to defer the UI update until after the next paint, reducing blocking time */
    if (activeBtn) {
        requestAnimationFrame(function() {
            updatePreview(activeBtn, true); // true = isInitialLoad
        });
    }

    /* 5. IDLE CHAIN LOADER */
    initIdleChain(layout);

    /* 6. MOUSE DRAG SCROLL */
    enableDragScroll(layout);
  });

  /* --- HELPER: MARQUEE ENGINE --- */
  function initMarquee(layout) {
    var scrollEnable = layout.getAttribute("data-scroll-enable") === "true";
    if (!scrollEnable) return function() {}; 

    var rows = layout.querySelectorAll(".ts-grid-row");
    var speedSetting = parseInt(layout.getAttribute("data-scroll-speed")) || 30;
    var baseSpeed = speedSetting / 40; 
    var directionSetting = layout.getAttribute("data-scroll-direction") || "alternate";
    var pauseOnHover = layout.getAttribute("data-scroll-pause") === "true";

    var clonesList = [];
    var animIds = [];
    var eventRemovers = [];

    rows.forEach(function(row, index) {
       var buttons = Array.from(row.children);
       if (buttons.length === 0) return; 

       for(var i=0; i<6; i++) {
         buttons.forEach(function(btn) {
           var clone = btn.cloneNode(true);
           clone.classList.add('ts-marquee-clone'); 
           row.appendChild(clone);
           clonesList.push(clone);
         });
       }

       var dir = "left";
       if (directionSetting === "right") dir = "right";
       else if (directionSetting === "alternate") {
          dir = (index % 2 === 0) ? "left" : "right";
       }

       var isPaused = false;
       var scrollPos = (dir === "right") ? row.scrollWidth / 2 : 0; 
       row.scrollLeft = scrollPos;

       function step() {
         if (!isPaused) {
           var limit = row.scrollWidth / 2;
           if (dir === "left") {
             scrollPos += baseSpeed;
             if (scrollPos >= limit) scrollPos = 0; 
           } else {
             scrollPos -= baseSpeed;
             if (scrollPos <= 0) scrollPos = limit;
           }
           row.scrollLeft = scrollPos;
         } else {
           scrollPos = row.scrollLeft;
         }
         var id = requestAnimationFrame(step);
         animIds.push(id);
       }
       
       var startId = requestAnimationFrame(step);
       animIds.push(startId);

       if (pauseOnHover) {
          var resumeTimer;

          function pause() { 
             isPaused = true; 
             if(resumeTimer) clearTimeout(resumeTimer);
          }
          
          function resume() { 
             if(resumeTimer) clearTimeout(resumeTimer);
             resumeTimer = setTimeout(function(){
                 isPaused = false;
             }, 2500);
          }

          var pEvents = ["touchstart", "mouseenter"];
          var rEvents = ["touchend", "mouseleave", "touchcancel"];
          pEvents.forEach(evt => {
            row.addEventListener(evt, pause, {passive: true});
            eventRemovers.push(() => row.removeEventListener(evt, pause));
          });
          rEvents.forEach(evt => {
            row.addEventListener(evt, resume);
            eventRemovers.push(() => row.removeEventListener(evt, resume));
          });
       }
    });

    return function cleanup() {
      animIds.forEach(cancelAnimationFrame);
      animIds = [];
      clonesList.forEach(function(clone) { clone.remove(); });
      clonesList = [];
      eventRemovers.forEach(function(remove) { remove(); });
      rows.forEach(function(row) { row.scrollLeft = 0; });
    };
  }

  /* --- HELPER: IDLE LOADER --- */
  function initIdleChain(layout) {
    var uniqueUrls = new Set();
    var thumbs = layout.querySelectorAll(".ts-thumb");
    thumbs.forEach(function(t) {
        var s1 = t.getAttribute("data-src-dark");
        var s2 = t.getAttribute("data-src-light");
        var s3 = t.getAttribute("data-src-alt-dark");
        var s4 = t.getAttribute("data-src-alt-light");
        if(s1) uniqueUrls.add(s1);
        if(s2) uniqueUrls.add(s2);
        if(s3) uniqueUrls.add(s3);
        if(s4) uniqueUrls.add(s4);
    });
    var queue = Array.from(uniqueUrls);
    if (queue.length === 0) return;
    setTimeout(function() { processQueue(queue); }, 3000);
  }

  function processQueue(queue) {
      if (queue.length === 0) return;
      var nextUrl = queue.shift();
      var img = new Image();
      var nextStep = function() { setTimeout(function() { processQueue(queue); }, 200); };
      img.onload = nextStep;
      img.onerror = nextStep;
      img.src = nextUrl;
  }

  /* --- HELPER: DRAG TO SCROLL --- */
  function enableDragScroll(layout) {
    const sliders = layout.querySelectorAll('.ts-grid-row');
    
    sliders.forEach(slider => {
      const images = slider.querySelectorAll('img');
      images.forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.style.cursor = 'grabbing';
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.style.cursor = 'grab';
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.style.cursor = 'grab';
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault(); 
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; 
        slider.scrollLeft = scrollLeft - walk;
      });
      
      slider.style.cursor = 'grab';
    });
  }
});